import React from 'react';
import Modal from 'react-modal';
import Reflux from 'reflux';
import createReactClass from 'create-react-class';

import formActions from '../../actions/form-actions';
import formStateStore from '../../stores/form-state-store';

import FilterSelector from './filter-selector';

const appElement = document.querySelector('#bssp-app');

export default createReactClass({
	mixins: [Reflux.connect(formStateStore, 'formState')],

	handleSearchFieldChange: function (e) {
		this.setState({formState: {searchTerm: e.target.value}});
		formActions.search(e.target.value);
	},

	renderCategoryFilter: function () {
		const hasValue = !!(
			this.state.formState.selectedFilterOption ||
			this.state.formState.selectedAdditionalFilterOption
		);

		// TODO: Show label for both filters?
		const label =
			(hasValue &&
				(this.state.formState.selectedFilterOptionName ||
					this.state.formState.selectedAdditionalFilterOptionName)) ||
			'Filtern …';

		return (
			<span className="bssp-filter-input">
				<button
					className="bssp-filter-input__open-button"
					type="button"
					onClick={formActions.openFilter}
				>
					{label}
				</button>
				{hasValue ? (
					<button
						className="bssp-filter-input__reset-button bssp-form__reset-button"
						type="button"
						onClick={formActions.reset}
					>
						<i className="bssp-icon bssp-icon--reset" />
					</button>
				) : null}
			</span>
		);
	},

	renderSearchField: function () {
		const hasValue = !!this.state.formState.searchTerm;
		return (
			<span className="bssp-search-input">
				<svg
					className="bssp-search-input__icon"
					xmlns="http://www.w3.org/2000/svg"
					width="17.125"
					height="16.688"
					viewBox="0 0 17.125 16.688"
				>
					<path
						fill="#000000"
						fillRule="evenodd"
						d="M6.443.001A6.443 6.443 0 1 1 0 6.443 6.443 6.443 0 0 1 6.443.001zm0 2.013a4.43 4.43 0 1 1-4.429 4.429 4.429 4.429 0 0 1 4.428-4.429zm9.282 14.677l-5.364-5.364 1.391-1.389 5.364 5.364z"
					/>
				</svg>

				<input
					className="bssp-search-input__field"
					placeholder="Suchen"
					value={this.state.formState.searchTerm || ''}
					onChange={this.handleSearchFieldChange}
				/>
				{hasValue ? (
					<button
						className="bssp-search-input__reset-button bssp-form__reset-button"
						type="button"
						onClick={formActions.reset}
					>
						<i className="bssp-icon bssp-icon--reset" />
					</button>
				) : null}
			</span>
		);
	},

	render: function () {
		const {
			filterOpen,
			searchTerm,
			selectedFilterOption,
			selectedAdditionalFilterOption,
			selectedFilterOptionName,
			selectedAdditionalFilterOptionName,
		} = this.state.formState;

		const isSearchActive = !!searchTerm;
		const isSelectActive = !!(
			selectedFilterOption || selectedAdditionalFilterOption
		);
		const classes = `bssp-form ${
			isSelectActive
				? 'bss-form--active bss-form--select'
				: isSearchActive
				? 'bss-form--active bss-form--search'
				: ''
		}`;
		const filterButton = this.renderCategoryFilter();
		const searchField = this.renderSearchField();

		return (
			<form
				className={classes}
				onSubmit={(e) => {
					e.preventDefault();
					document.activeElement.blur();
				}}
			>
				<div className="clearfix">
					{filterButton}
					{searchField}
				</div>
				<Modal
					className="bssp-filter-selector-container"
					isOpen={filterOpen}
					contentLabel="Filter"
					onRequestClose={formActions.closeFilter}
					appElement={appElement}
					style={{
						...Modal.defaultStyles,
						overlay: {
							...Modal.defaultStyles.overlay,
							zIndex: 1000,
							background: 'rgba(30, 30, 30, 0.6)',
							backdropFilter: 'blur(5px)',
							WebkitBackdropFilter: 'blur(5px)',
						},
						content: {},
					}}
				>
					<FilterSelector
						categoryFilters={this.props.categoryFilters}
						categoryColorMap={this.props.categoryColorMap}
						additionalCategoryFilters={
							this.props.additionalCategoryFilters
						}
						selectedFilterOption={selectedFilterOption}
						selectedFilterOptionName={selectedFilterOptionName}
						selectedAdditionalFilterOption={
							selectedAdditionalFilterOption
						}
						selectedAdditionalFilterOptionName={
							selectedAdditionalFilterOptionName
						}
					/>
				</Modal>
			</form>
		);
	},
});
